import { memo, type ReactNode } from "react";
import { styled } from "~/common/mui";

const SummaryFrameRoot = styled("div")(({ theme }) => ({
  width: "100%",
  paddingBottom: theme.spacing(3.75),
  borderBottom: `1px solid ${theme.palette.divider}`,
  "&:last-child": {
    borderBottom: "none",
  },
  "& h3": {
    margin: 0,
  },
}));

const SummaryFrameTitle = styled("div")(({ theme }) => ({
  color: "#c1c0c0",
  ...theme.typography.labelMedium,
  paddingTop: theme.spacing(3.75),
  display: "flex",
}));

const SummaryFrame = (props: { num: number; name: ReactNode; children?: ReactNode; containerClassName?: string }) => {
  const { num, name, children, containerClassName } = props;
  return (
    <SummaryFrameRoot>
      <SummaryFrameTitle>
        <span className={"f-pre"}>{num}. </span>
        <span>{name}</span>
      </SummaryFrameTitle>
      {children && (
        <div className={"scha__lc-summary__step-" + num + " pt-2 " + containerClassName ? containerClassName : ""}>
          {children}
        </div>
      )}
    </SummaryFrameRoot>
  );
};

export default memo(SummaryFrame);
